import StoreContainer from "./stores/StoreContainer";
import { BootOptions, EcommerceData } from "./types";

const Velaro = (window.parent.window as any).Velaro;
const map: any = {};

/**
 * all methods declared here will be exposed to the public api.
 */

const PublicApi = {
  async boot(opts: BootOptions, callback?: Function): Promise<void> {
    await StoreContainer.BootStore.boot(opts, callback);
  },

  destroy(): void {
    StoreContainer.BootStore.destroy();
  },

  mountDynamicButton(opts: { el: HTMLElement }): void {
    StoreContainer.DynamicButtonStore.mountDynamicButton(opts);
  },

  mountCallButton(opts: { el: HTMLElement }): void {
    StoreContainer.CallButtonStore.mountCallButton(opts);
  },

  mountPopoutButton(opts: { el: HTMLElement }): void {
    StoreContainer.DynamicButtonStore.mountPopoutButton(opts);
  },

  async isChatAvailable(
    callback: (isAvailable: boolean) => void
  ): Promise<void> {
    await StoreContainer.AvailabilityStore.isChatAvailable(callback);
  },

  async expand(): Promise<void> {
    await StoreContainer.FrameStore.expand();
  },

  async collapse(): Promise<void> {
    await StoreContainer.FrameStore.collapse();
  },

  async popout(): Promise<void> {
    await StoreContainer.FrameStore.popout();
  },

  async popin(): Promise<void> {
    await StoreContainer.FrameStore.popin();
  },

  isExpanded(): boolean {
    return StoreContainer.FrameStore.isExpanded();
  },

  onExpand(callback: () => void): void {
    return StoreContainer.FrameStore.onExpand(callback);
  },

  onCollapse(callback: () => void): void {
    return StoreContainer.FrameStore.onCollapse(callback);
  },

  isPopOut(): boolean {
    return StoreContainer.FrameStore.isPopOut();
  },

  setLauncherVisibility(visibility: string): void {
    StoreContainer.FrameStore.setLauncherVisibility(visibility);
  },

  async addConversion(conversion: {
    conversionId: any;
    dollarAmount: any;
    customData: any;
  }): Promise<void> {
    await StoreContainer.ConversionStore.addConversion(conversion);
  },

  postEcommerceData(data: EcommerceData): void {
    StoreContainer.EcommerceStore.postEcommerceData(data);
  },

  linkToEcommerceCampaign(id: string, pageUrl: string): void {
    StoreContainer.EcommerceStore.linkToEcommerceCampaign(id, pageUrl);
  },

  linkToEcommerceId(id: string, url: string): void {
    StoreContainer.EcommerceStore.linkToEcommerceId(id, url);
  },

  recordEcommerceSale(id: string, url: string): void {
    StoreContainer.EcommerceStore.recordEcommerceSale(id, url);
  },

  testDisconnect(): void {
    StoreContainer.ChatStore.testDisconnect();
  },

  testReconnect(): void {
    StoreContainer.ChatStore.testReconnect();
  },

  onVisitorLoaded(callback: () => void): void {
    StoreContainer.VisitorStore.onLoaded(callback);
  },

  getVisitorId(): string {
    return StoreContainer.VisitorStore.getVisitorId();
  },

  enableCookies(): void {
    return StoreContainer.SettingStore.setDisableCookies(false);
  },

  disableCookies(): void {
    return StoreContainer.SettingStore.setDisableCookies(true);
  },

  onQueueEntered(callback: () => void): void {
    return StoreContainer.ChatStore.onChatQueued(callback);
  },

  onAgentAssigned(callback: () => void): void {
    return StoreContainer.ChatStore.onChatAssigned(callback);
  },

  onReceiveMessage(callback: (message: any) => void): void {
    return StoreContainer.ChatStore.onReceiveMessage(callback);
  },

  onAgentTyping(callback: (agentsTyping: string[]) => void): void {
    return StoreContainer.ChatStore.onAgentsTypingChange(callback);
  },

  onChatClosed(callback: () => void): void {
    return StoreContainer.EngagementStore.onChatClosed(callback);
  },

  onAgentClosed(callback: () => void): void {
    return StoreContainer.ChatStore.onAgentClose(callback);
  },

  onShowPrechatSurvey(callback: () => void): void {
    return StoreContainer.EngagementStore.onReceivePreChatSurvey(callback);
  },

  onShowPostchatSurvey(callback: () => void): void {
    return StoreContainer.EngagementStore.onReceivePostChatSurvey(callback);
  },

  onShowUnavailableSurvey(callback: () => void): void {
    return StoreContainer.EngagementStore.onReceiveUnavailableSurvey(callback);
  },

  onShowUnavailableHtml(callback: () => void): void {
    return StoreContainer.EngagementStore.onReceiveUnavailableHtml(callback);
  },

  onShowUnavailableUrl(callback: () => void): void {
    return StoreContainer.EngagementStore.onReceiveUnavailableUrl(callback);
  },

  setClickToCall(clickToCall: boolean) {
    StoreContainer.SettingStore.setClickToCall(clickToCall);
  }
};

function expose(funcName: string, context: any, func: any) {
  map[funcName] = { context, func };
}

/**
 * Invoke a method called from the public API
 */
function invoke(funcName: string, ...args: Array<any>) {
  const result = map[funcName];

  if (!result) {
    throw new Error(`${funcName} is not defined`);
  }

  return result.func.apply(result.context, args);
}

Object.keys(PublicApi).forEach((key) => {
  expose(key, PublicApi, (PublicApi as any)[key]);
});

export function dequeue() {
  Velaro.c = (args: IArguments) => {
    return invoke.apply(null, args);
  };

  Velaro.q.forEach(Velaro.c);
}
